<template>
  <ToastModal
    ref="modal"
    :title="$t('LandingsPage.Undershirts.SizeChart.Title')"
    show-mobile-footer
    :width="1014"
    modal-id="UndershirtsSizeModal"
  >
    <div class="py-6 undershirts-size-modal">
      <SizeChartMenu :title="$t('SignUp.Women.SizeChart.SizeSystem')" :sizechart-zone="sizechartZone" :country="country" class="mb-6" @click="sizechartZone = $event.zone" />
      <OTable title="">
        <thead>
          <tr>
            <th />
            <th v-text="'XS'" />
            <th v-text="'S'" />
            <th v-text="'M'" />
            <th v-text="'L'" />
            <th v-text="'XL'" />
            <th v-text="'XXL'" />
            <th v-text="'3XL'" />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-if="isUk" class="text-left" v-text="$t('LandingsPage.Undershirts.SizeChart.ChestInInches')" />
            <td v-else class="text-left" v-text="$t('LandingsPage.Undershirts.SizeChart.ChestInCM')" />
            <td v-for="size in chestSizes[sizechartZone]" :key="size" v-text="size" />
          </tr>
          <tr>
            <td v-if="isUk" class="text-left" v-text="$t('LandingsPage.Undershirts.SizeChart.WaistInInches')" />
            <td v-else class="text-left" v-text="$t('LandingsPage.Undershirts.SizeChart.WaistInCM')" />
            <td v-for="size in waistSizes[sizechartZone]" :key="size" v-text="size" />
          </tr>
        </tbody>
      </OTable>
    </div>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import OTable from '@/components/OTable'
import { SizechartZones } from '@/enums/sizechart'
import SizeChartMenu from '@/components/Women/SizeChartMenu'
import { CountryCodes } from '@/enums/general'

export default {
  name: 'UndershirtsSizeModal',
  components: { ToastModal, OTable, SizeChartMenu },
  props: {
    country: {
      type: String,
      default: CountryCodes.netherlands
    }
  },
  data () {
    return {
      sizechartZone: SizechartZones.eu
    }
  },
  computed: {
    chestSizes () {
      const euSizes = [
        '90 - 94',
        '94 - 98',
        '98 - 102',
        '102 - 106',
        '106 - 114',
        '114 - 118',
        '118 - 122'
      ]

      const ukSizes = [
        '35.4 - 37.0',
        '37.0 - 38.6',
        '38.6 - 40.2',
        '40.2 - 41.7',
        '41.7 - 44.9',
        '44.9 - 46.5',
        '46.5 - 48'
      ]

      return {
        [SizechartZones.eu]: euSizes,
        [SizechartZones.uk]: ukSizes
      }
    },
    waistSizes () {
      const euSizes = [
        '78 - 82',
        '82 - 86',
        '86 - 90',
        '90 - 94',
        '94 - 102',
        '102 - 106',
        '106 - 110'
      ]

      const ukSizes = [
        '30.7 - 32.3',
        '32.3 - 33.9',
        '33.9 - 35.4',
        '35.4 - 37',
        '37 - 40.2',
        '40.2 - 41.7',
        '41.7 - 43.3'
      ]

      return {
        [SizechartZones.eu]: euSizes,
        [SizechartZones.uk]: ukSizes
      }
    },
    isUk () {
      return this.sizechartZone === SizechartZones.uk
    }
  },
  methods: {
    onModalClose () {
      this.$refs.modal.onModalClose()
    },
    toggleActivation () {
      this.$refs.modal.toggleActivation()
    }
  }
}
</script>

<style scoped lang="postcss">
.undershirts-size-modal {
  >>> .FR-button {
    @apply hidden;
  }

  >>> .size-chart-menu-button-active {
    @apply bg-green-400 border-green-400;
  }
}
</style>
